import axios from 'axios';

import { ITagline } from '../infrastructure/interfaces';

export default class TaglineService {

  static createTagline(tagline: ITagline) {
    return new Promise((resolve, reject) => {
      axios
        .post('/taglines', { tagline })
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }

  static updateTagline(tagline: ITagline) {
    return new Promise((resolve, reject) => {
      axios
        .put('/taglines', { tagline })
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }

  static deleteTagline(id: number) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/taglines/${id}`)
        .then((res) => {
          const { id } = res.data;
          resolve(id);
        })
        .catch(error => reject(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/TaglineService.ts